import {getHashVar, scrollToElement} from "./Util";

/* Анкоры  */

/**
 * ссылка в формате <a href="#anchor_name" class="js-anchor"></a>
 * **/

$('.js-anchor').on('click', function () {
    let id = $(this).attr('href').split('#')[1];

    if (App.mobile && App.H.hasClass('_mobile-menu--opened')) {
        App.H.addClass('_mobile-menu--closing').removeClass('_mobile-menu--opened');
        setTimeout(() => {
            App.H.removeClass('_mobile-menu--closing _mobile-menu-sublist--opened');
            $('.js-c-mobile-menu-content-head').show();
            $('.js-c-mobile-menu-sublist._active').removeClass('_active');
            $('.js-c-mobile-user-sublist._active').removeClass('_active');
            scrollToElement($(`#${id}`));
        }, 300);
    }
    if (App.mobile && App.H.find('.js-common-popup').hasClass('common-popup--opened')) {
        $('.js-common-popup-close').trigger('click');
    }

    scrollToElement($(`#${id}`));
});


/**
 * Если в ссылке есть хеш и на странице есть блок для этого хеша, то скроллим к нему
 * **/
if (getHashVar()) {
    let $anchorLink = $(`#${getHashVar()}`);
    let $anchorLinkWrap = $(`#${getHashVar()}-wrap`);

    if ($anchorLinkWrap.length) {
        setTimeout(function () {
            scrollToElement($anchorLinkWrap);
        }, 500);
    }

    if ($anchorLink.length) {
        setTimeout(function () {
            scrollToElement($anchorLink);
        }, 500);
    }
}

/**
 * Для скрытия/открытия якорного содержания в статьях на конструкторе на мобилке
 * **/
if ($('.collapse-mobile-btn').length > 0) {
    setTimeout(function () {
        $('.collapse-mobile-btn').off('click').on('click', function (e) {
            $(this).toggleClass('_open');
            $(this).siblings('.collapse-mobile').toggleClass('_open');

            if ($(this).is('._open')) {
                $(this).html($(this).data('replace-text'));
            } else {
                $(this).html($(this).data('default-text'));
            }

            e.preventDefault();
        });
    }, 1000);
}
